import React, { CSSProperties } from 'react'
import { MyWorkType } from '../../containers/ProfileContestsWorkPage/types'

// Styles
import './styles.scss'

// Components
import ContestsDatabaseItem from '../ContestsDatabaseItem'

export default ({
  works,
  style,
}: {
  works: MyWorkType[]
  style?: CSSProperties
}) => {
  return (
    <div className={'database'} style={style}>
      <div className={'database__row'}>
        {works.length ? (
          works.map(item => (
            <ContestsDatabaseItem key={item.user_contest_id} item={item} />
          ))
        ) : (
          <h3 className={'database__not-found'}>Работы не найдены!</h3>
        )}
      </div>
    </div>
  )
}
